<script lang="ts">
  import { EditorJs } from 'query-strapi-v4';
  type Block = $$Generic<EditorJs.Code | undefined>;
  export let block = undefined as Block;
</script>

<pre class="bg-background border rounded-lg overflow-y-scroll">{@html block.data.code}</pre>
